import React, { FC } from 'react'

import * as S from './FieldTag.styles'
import { Badge } from '../Badge'
import { FieldTagProps } from './FieldTag.types'
import { getMatchingLabels, labelByTagKind } from './FieldTag.utils'
import { mainColors } from '../../styles'

export const FieldTag: FC<FieldTagProps> = ({ tags, internalTag }) => {
  const matchingLabels = getMatchingLabels({ tags, internalTag })

  return matchingLabels?.length
    ? matchingLabels?.map(tag => (
        <S.TagContainer key={tag}>
          &bull;
          <Badge
            badgeColor={{
              color: mainColors.neutralExtremelyDark,
              background: 'none',
            }}
            styles={{ border: 'none', cursor: 'default' }}
          >
            {labelByTagKind[tag]}
          </Badge>
        </S.TagContainer>
      ))
    : null
}
